import React from 'react'
import { getDiscountPoolById } from 'discounts/redux'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import PressAndHoldButton from 'uiComponents/buttons/pressAndHoldButton'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import { removeHash } from 'utils/hash'
import { useDeleteDiscountPoolMutation } from 'discounts/reduxQuery'
import { useParams } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import { addMessage, removeMessage } from 'uiComponents/messages/actions'
import { Trans, useTranslation } from 'translations'

interface DeletePoolModalProps {
    poolUuid: string
}

export const DeletePoolModal = ({ poolUuid }: DeletePoolModalProps) => {
    const { t } = useTranslation()
    const pool = useAppSelector(getDiscountPoolById(poolUuid))
    const [deletePool] = useDeleteDiscountPoolMutation()
    const dispatch = useAppDispatch()
    const routeParams = useParams<BaseRouteParams>()

    const onConfirm = () => {
        deletePool({ accountSlug: routeParams.accountSlug, uuid: poolUuid })
            .unwrap()
            .then(removeHash)
            .catch(() => {
                const errorVisibleTime = 5000
                dispatch(addMessage('delete_pool_error', 'error', t('discounts.deletePool.error')))

                setTimeout(() => {
                    dispatch(removeMessage('delete_pool_error'))
                }, errorVisibleTime)
            })
    }

    return (
        <Modal className="delete-discount-pool-modal" title={t('discounts.deletePool.title')} onDismiss={removeHash}>
            <ModalBody>
                <p>
                    <Trans
                        i18nKey="discounts.deletePool.body"
                        values={{ name: pool?.name ?? '' }}
                        components={{ b: <strong /> }}
                    />
                </p>
            </ModalBody>
            <ModalFooter>
                <CancelButton className="back-button" secondary size="large" onClick={removeHash}>
                    {t('common.cancel')}
                </CancelButton>
                <PressAndHoldButton text={t('common.delete')} destructive onComplete={onConfirm} />
            </ModalFooter>
        </Modal>
    )
}
